import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "100%",
      temporary: "",
      stateless: _vm.isMakingDrawerStateless
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer px-8"
  }, [_c("div", {
    staticClass: "drawer-section-title"
  }, [_c("div", [_c(VBtn, {
    staticClass: "mr-4",
    on: {
      click: _vm.closeDrawer
    }
  }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" Order files ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    on: {
      click: function click($event) {
        return _vm.openTagsDialog();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-tag mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Manage tags ")], 1)], 1), _c("section", {
    staticClass: "drawer-section-order"
  }, [_vm.loadings.isLoadingOrderFiles ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [!_vm.orderDocuments.length ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v("No files yet")]) : _vm._e(), _c("div", {
    staticClass: "drawer-file-list"
  }, _vm._l(_vm.orderDocuments, function (file) {
    return _c("div", {
      key: file.id,
      staticClass: "global-file-chip"
    }, [_c("div", {
      staticClass: "tag"
    }, [file.tag ? _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: "",
        close: _vm.canRemoveTagFromDocument(file),
        "close-icon": "mdi-close-thick"
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeTagFromDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("b", [_vm._v(_vm._s(file.tag.name))])], 1) : _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openAddTagToDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("p", {
      staticClass: "font-italic ma-0"
    }, [_vm._v("Add tag")]), _c(VIcon, {
      attrs: {
        right: ""
      }
    }, [_vm._v("mdi-plus-thick")])], 1)], 1), _c(VChip, {
      staticClass: "drawer-file-chip",
      attrs: {
        close: _vm.canDeleteDocument(file),
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openFileUrl(file.url);
        },
        "click:close": function clickClose($event) {
          return _vm.removeFile(file.id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        large: "",
        left: ""
      }
    }, [_vm._v("mdi-cloud-download")]), _vm._v(" " + _vm._s(file.filename) + " ")], 1)], 1);
  }), 0)], _c("div", {
    staticClass: "withBeforeSeparator"
  }, [_c(VForm, {
    staticClass: "dfwa-form"
  }, [_c("div", {
    staticClass: "title text-left mb-2"
  }, [_vm._v("Upload new file")]), _vm.gettingDocumentTags.results.length ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.gettingDocumentTags.results,
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      "item-value": "id",
      "item-text": "name",
      placeholder: "Tag",
      "hide-details": "auto",
      label: "Document tag"
    },
    model: {
      value: _vm.uploadAdditionalData.tagId,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadAdditionalData, "tagId", $$v);
      },
      expression: "uploadAdditionalData.tagId"
    }
  }) : _vm._e(), _vm.drawer && !_vm.loadings.isLoadingOrderFiles ? _c("UploaderV2", {
    key: "attached-files",
    attrs: {
      canClear: "",
      idInput: "file-upload-global",
      url: _vm.uploadUrl,
      additionalFormData: _vm.uploadAdditionalFormData,
      fileTypes: [".xlsx", ".xlsm", ".jpg", ".png", ".gif", ".pdf"],
      label: "Attach File(s) to order"
    },
    on: {
      "click:upload": _vm.upload
    }
  }) : _vm._e()], 1)], 1)], 2), _c("OrderRelatedFilesTable", {
    attrs: {
      title: "Product files",
      items: _vm.wineDocuments,
      documentType: "wine",
      nameKey: "display_name",
      idKey: "id_wine",
      route: "adminWineDetails",
      loading: _vm.loadings.isLoadingWineFiles,
      documentTags: _vm.gettingDocumentTags.results
    },
    on: {
      filterList: function filterList(filters) {
        _vm.updateFilters(filters);
        _vm.fetchWineDocuments();
      }
    }
  }), _c("OrderRelatedFilesTable", {
    attrs: {
      title: "Producer files",
      items: _vm.wineryDocuments,
      documentType: "winery",
      nameKey: "name",
      idKey: "id",
      route: "adminProducerDetails",
      loading: _vm.loadings.isLoadingWineryFiles,
      documentTags: _vm.gettingDocumentTags.results
    },
    on: {
      filterList: function filterList(filters) {
        _vm.updateFilters(filters);
        _vm.fetchWineryDocuments();
      }
    }
  })], 1), _c("ManageDocumentsTagsDialog", {
    ref: "ManageDocumentsTagsDialog",
    on: {
      tagListChanged: function tagListChanged($event) {
        return _vm.tagListChangedUpdate();
      },
      documentTagsFetched: _vm.fetchDocumentTags
    }
  }), _c("AddTagToDocumentDialog", {
    ref: "AddTagToDocumentDialog",
    attrs: {
      isTagYourInvoicesForbidden: _vm.isOrderImporterInternal
    },
    on: {
      tagAddedToDocument: function tagAddedToDocument($event) {
        return _vm.tagListChangedUpdate();
      },
      openManageTagsDialog: function openManageTagsDialog($event) {
        return _vm.openTagsDialog();
      }
    }
  }), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };